/*
 * SonarQube
 * Copyright (C) 2009-2025 SonarSource SA
 * mailto:info AT sonarsource DOT com
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with this program; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import { SystemUpgradeDownloadUrls } from './system';

export enum EditionKey {
  community = 'community',
  developer = 'developer',
  enterprise = 'enterprise',
  datacenter = 'datacenter',
}

export interface Edition {
  downloadProperty: keyof SystemUpgradeDownloadUrls;
  homeUrl: string;
  key: EditionKey;
  name: string;
}

export interface License {
  canActivateGracePeriod: boolean;
  contactEmail: string;
  edition: string;
  expiresAt: string;
  gracePeriodEndDate?: string;
  gracePeriodExpired?: boolean;
  isExpired: boolean;
  isOfficialDistribution: boolean;
  isSupported: boolean;
  isValidEdition: boolean;
  isValidServerId: boolean;
  loc: number;
  maxLoc: number;
  plugins: string[];
  remainingLocThreshold: number;
  serverId: string;
  type: string;
}

export type LicenseV2Features = Array<{
  endDate: string | null;
  name: string;
  startDate: string | null;
}>;

export interface LicenseV2 {
  activatedOnline?: boolean;
  disabled: boolean;
  edition: string;
  expirationDate: string;
  expired: boolean;
  extraDays: number;
  features: LicenseV2Features;
  lastRefreshDate: string;
  legacy: boolean;
  licenseKey: string | null;
  loc: number;
  maxLoc: number;
  officialDistribution: boolean;
  remainingLocThreshold: number;
  serverId: string;
  startDate: string | null;
  supported: boolean;
  type: string;
  validEdition: boolean;
}

export interface PurchaseableFeature {
  featureKey: string;
  isAvailable?: boolean;
  isEnabled?: boolean;
  url?: string;
}
